import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";
import { moduleName as recordsModuleName } from "../records";
import {
  vsComponentName as processDetailNewComponentName,
  processDetailComponentNewOptions,
} from "./views/processDetail";

import {
  processViewComponentOptions,
  vsComponentName as processViewComponentName,
} from "./views/ProcessGroupGrid/component";

import {
  vsServiceName as ProcessInformationServiceName,
  ProcessInformationServiceProvider,
} from "./services/processInformationService";

import { vsModuleName as signatureModuleName } from "../ui/signature/module";

import { vsModuleName as objectsModule } from "./config/objects";
import {
  processGridComponentOptions,
  vsComponentName as processGridComponentName,
} from "./views/ProcessInstancesGrid";
import { routeConfig } from "./routes";

import { vsModuleName as workItemTypeModule } from "./workItems/types/module";

import { vsModuleName as selectRecordModalModule } from "../records/services/selectRecordModal";
import {
  ProcessNotesModalComponentOptions,
  vsComponentName as ProcessNotesModalComponentName,
} from "./views/processDetail/notes";

import { vsModuleName as processTimelineModuleName } from "./views/processDetail/timeline";

export const vsName = "SlotTrak.Process";
angular
  .module(vsName, [
    uiRouter,
    recordsModuleName,
    signatureModuleName,
    "ui.bootstrap",
    objectsModule,
    selectRecordModalModule,
    workItemTypeModule,
    processTimelineModuleName,
  ])
  .config(routeConfig)
  .component(processDetailNewComponentName, processDetailComponentNewOptions)
  .component(ProcessNotesModalComponentName, ProcessNotesModalComponentOptions)
  .component(processViewComponentName, processViewComponentOptions)
  .component(processGridComponentName, processGridComponentOptions)
  .provider(ProcessInformationServiceName, ProcessInformationServiceProvider);
export default vsName;
